import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {Store} from '../../lib/App/Store';
import {CatalogPreview} from '../../components/Catalog/CatalogPreview';

interface CatalogPageProps {
  id: string;
  store: Store;
}

@inject('store')
@observer
export class CatalogPage extends React.Component<CatalogPageProps, {}>{
  private get controller() {
    const {store} = this.props;

    const {catalogController} = store.context.appData;

    return catalogController;
  }

  async componentDidMount() {
    const {id} = this.props;

    await this.controller.loadCatalog(id);
  }

  render() {
    if (!this.controller.catalog) {
      return <p>Loading</p>;
    }

    return (
      <CatalogPreview
        catalog={this.controller.catalog}
        displayMode={this.controller.displayMode}
        updateActivePage={this.controller.updateActivePage}
      />
    )
  }
}
